import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { KatchaCoreModule } from '@mobile/modules/core/core.module';
import { IonComponentPreloaderModule } from '@mobile/widgets/commons/ion-component-preloader';
import { KatchaApiConfig, KatchaAppConfig, KatchaAssetConfig, KatchaCaptchaConfig, KatchaLanguageConfig, KatchaSocketConfig } from '../configs';
import { AppComponent } from './app.component';

@NgModule({
  entryComponents: [],
  imports: [
    IonicModule,
    IonComponentPreloaderModule,
    KatchaCoreModule.forRoot({
      captcha: KatchaCaptchaConfig,
      api: KatchaApiConfig,
      app: KatchaAppConfig,
      asset: KatchaAssetConfig,
      language: KatchaLanguageConfig,
      socket: KatchaSocketConfig
    }),
    RouterModule.forRoot([
      { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
      { path: 'partner', loadChildren: () => import('./partner/partner.module').then(m => m.PartnerModule) },
      { path: '', loadChildren: () => import('./main/main.module').then(m => m.MainModule) },
      { path: '**', pathMatch: 'full', redirectTo: '/' }
    ], {
      preloadingStrategy: PreloadAllModules
    })
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() { }
}
